/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

import './component006.less';
import { Button } from 'antd';

interface IComponents006Item {
  img: string;
  title: string;
}
interface IComponents006Props {
  top: string;
  items: IComponents006Item[];
}

const Components004: React.FunctionComponent<IComponents006Props> = ({
  top,
  items,
}) => {
  const [currPage, setCurrPage] = useState(0);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  return (
    <>
      <div className="top" dangerouslySetInnerHTML={{ __html: top }} />
      <div className="components006">
        <div className="content">
          <div
            className="title"
            dangerouslySetInnerHTML={{ __html: items[currPage]?.title }}
          />
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => setPage(-1)}
          >
            <img src={ImgArrowLeft} alt="" />
          </Button>
          <div className="pic">
            <img
              src={
                require(`../../../../../assets/${items[currPage]?.img}`).default
              }
              alt=""
            />
          </div>
          <Button
            className={`next-button ${currPage === 1 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === items.length - 1}
            onClick={() => setPage(1)}
          >
            <img src={ImgArrowRight} alt="" />
          </Button>
        </div>
      </div>
    </>
  );
};

export default Components004;
